<ng-container [formGroup]="form">
  <ng-container
    *ngFor="let control of form.controls; let index = index"
    [formGroupName]="index"
  >
    <div class="u-full-width budget">
      <button
        mat-icon-button
        mat-raised-button
        color="accent"
        (click)="removeBudget(index)"
        matTooltip="{{'projects.Rimuovi budget' | translate}}"
      >
        <mat-icon>delete</mat-icon>
      </button>
      <mat-form-field>
        <input matInput placeholder="{{'shared.Nome' | translate}}" formControlName="name" type="text" />
        <mat-error>{{'shared.Campo obbligatorio' | translate}}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="{{'shared.Budget' | translate}}"
          formControlName="budget"
          type="number"
        />
        <mat-icon matSuffix>euro</mat-icon>
        <mat-error>{{'projects.Budget non valido' | translate}}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="{{'shared.Budget ore' | translate}}"
          formControlName="hours"
          type="number"
        />
        <mat-error>{{'shared.Campo obbligatorio' | translate}}</mat-error>
        <mat-hint *ngIf="control?.value.hours && control?.value.budget">
          {{'shared.Ricavo giornaliero' | translate}} :
          {{
            (control?.value.budget / control?.value.hours) * 8 | customCurrency
          }}&nbsp;€
        </mat-hint>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          [matDatepicker]="fromDatePicker1"
          formControlName="start"
          placeholder="{{'shared.Inizio' | translate}}"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="fromDatePicker1"
        ></mat-datepicker-toggle>
        <mat-datepicker #fromDatePicker1></mat-datepicker>
        <mat-error>{{'projects.Data non valida' | translate}}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          [matDatepicker]="fromDatePicker2"
          formControlName="end"
          placeholder="{{'shared.Fine' | translate}}"
          [min]="control.controls['start']?.value"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="fromDatePicker2"
        ></mat-datepicker-toggle>
        <mat-datepicker #fromDatePicker2></mat-datepicker>
        <mat-error>{{'projects.Data non valida' | translate}}</mat-error>
      </mat-form-field>
      <mat-form-field class="u-full-width">
        <input
          matInput
          placeholder="{{'shared.Note' | translate}}"
          formControlName="notes"
          type="text"
        />
      </mat-form-field>
    </div>
  </ng-container>
</ng-container>
<div class="u-center-text">
  <button mat-raised-button type="button" color="accent" [disabled]="form.invalid" (click)="addBudget()">
    <span>{{'projects.Aggiungi fase di progetto' | translate}}</span>
  </button>
</div>
